import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { HierarchyLevelName } from "../../../Wrap/Constants/Enums/HierarchyLevelName";

export class HierarchyIdHelper {
    static toHierarchyIdString(hierarchyLevel: HierarchyLevelName, entityId: number): string {
        return hierarchyLevel.toString().padStart(3, "0") + "-" + entityId.toString().padStart(10, "0");
    }

    static generateHierarchyId(hierarchyIdString: string): { hierarchyLevel: HierarchyLevelName; entityId: number } {
        if (CommonHelper.isNullOrEmpty(hierarchyIdString)) {
            return { hierarchyLevel: HierarchyLevelName.NotSpecified, entityId: null };
        }

        try {
            const hierarchyIdParts = hierarchyIdString.split("-");
            const levelName = parseInt(hierarchyIdParts[0]) as HierarchyLevelName;
            const entityId = parseInt(hierarchyIdParts[1]);
            return { hierarchyLevel: levelName, entityId: entityId };
        } catch (Exception) {
            return { hierarchyLevel: HierarchyLevelName.NotSpecified, entityId: -1 };
        }
    }

    static Equals(h1: string, h2: string): boolean {
        const hierarchy1 = HierarchyIdHelper.generateHierarchyId(h1);
        const hierarchy2 = HierarchyIdHelper.generateHierarchyId(h2);
        return hierarchy1.hierarchyLevel === hierarchy2.hierarchyLevel && hierarchy1.entityId === hierarchy2.entityId;
    }
}
